export default __webpack_public_path__ + "assets/front/scss/error.8b9d2e67a873badf4f9a600f79e61691.css";